<template>
    <div>
        <Title title="预测" :logo="true" :tablist="tab_list" :tabactive="tab_active" @titleTabActive="titleTabActive"/>
<!--        <van-swipe :show-indicators="false" :loop="false">-->
<!--            :initial-swipe="tab_active"-->
<!--            <van-swipe-item>-->

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>

            <template v-if="coupon_list.length>0">
            <div class="free_tm free_tm2">优惠券<router-link to="/coupon">优惠说明</router-link></div>
            <div class="coupon coupon_m">
                <swiper :options="focusSwiperOption" ref="couponSwiper">
                    <swiper-slide v-for="(m,i) in coupon_list" :key="i">
                        <div :class="m.is_get === true?'item itemdis':'item couponget'" @click="getCoupon(m.id, i)">
                            <div class="amt">{{ m.amt }}<span>FXB</span></div>
                            <div class="name">{{ m.name }}</div>
                            <div class="time">剩余 /&nbsp;&nbsp;{{ m.surplus }}张</div>
                            <div class="tag" v-if="m.is_get">已领取</div>
                            <div class="tag" v-else>立即抢券</div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            </template>

            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
                <van-list v-model="isLoading"
                          finished-text="没有了~"
                          :immediate-check="false"
                          :finished="isFinished"
                          :error.sync="isError"
                          :error-text="match.list.length>0?'读取失败':''"
                          @load="onLoadMore">
                    <match_mini :data="match" v-if="match.list.length>0"/>
                </van-list>
            </van-pull-refresh>
        </template>

<!--            </van-swipe-item>-->
<!--            <van-swipe-item>-->
<!--                aaaa-->
<!--            </van-swipe-item>-->
<!--        </van-swipe>-->

    </div>
</template>

<script>
    import Title from './public/title'
    import match_mini from './public/match_mini'
    export default {
        name: "ball",
        components: {
            match_mini,
            Title
        },
        data() {
            return {
                match: {type: 3, list: []},
                tab_active: 0,
                tab_list: ['足球', '篮球'],
                ball: 1,
                page: 1,
                isInit: true,
                isRefresh: false,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,

                coupon_list: [],
                focusSwiperOption: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                }
            }
        },
        watch: {
            // '$route': {
            //   handler () {
            //       // console.log(this.$route.path)
            //       // console.log(this.$route)
            //       // this.getdata()
            //       // document.documentElement.scrollTop = this.$route.meta.y
            //   }
            // },
        },
        created() {
            let that = this
            if(that.$route.meta.ball){
                that.ball = that.$route.meta.ball
                that.page = 1
                that.tab_active = that.ball - 1
            }
            // console.log(1)
            that.$backTop()
            that.getdata()
        },
        methods: {
            titleTabActive(i){
                // console.log(v)
                this.tab_active = i
                this.ball = i+1
                this.page = 1
                this.isRefresh = false
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                this.$backTop()
                this.getdata()
            },
            onRefresh(){
                let that = this
                this.page = 1
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                setTimeout(function () {
                    that.getdata()
                }, 200)
            },
            onLoadMore(){
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                that.isLoadingError = false
                that.$get(that.$api.match_list,{ball: that.ball, page: that.page})
                    .then(function (res) {
                        if(res.code === 1) {
                            // if(that.isInit) that.$backTop()
                            if(that.page === 1) that.match.list = []

                            let tmplist = res.data.list
                            if(tmplist.length > 0) {
                                if (that.isRefresh) {
                                    that.match.list = tmplist
                                } else {
                                    that.match.list = that.match.list.concat(tmplist)
                                }
                            }
                            else{
                                that.isFinished = true
                            }
                            that.coupon_list = res.data.coupon
                            that.isInit = false
                        }
                        else{
                            that.isError = true
                        }
                        // console.log(that.isLoading)
                        // that.isLoading = false
                    })
                    .catch(function () {
                        that.isError = true
                        that.isLoadingError = true
                        // that.isLoading = false
                    })
                    .finally(function () {
                        that.isRefresh = false
                        that.isLoading = false
                    })
            },
            getCoupon(id, i){
                let that = this
                let item = that.coupon_list[i]
                if(item.is_get) return
                that.$post(that.$api.getCoupon, {cid: id}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                    }
                    else if(res.code === 2){
                        that.$toast.fail(res.msg)
                        item.is_get = true
                    }
                    else
                        that.$toast.fail(res.msg)
                })
            }
        },
        mounted() {
            //console.log('mounted')
        },
        beforeRouteEnter(to, from, next){
            next(vm =>{
                // console.log(from) // 上一页面的路由信息
                // console.log(to.meta.y, vm.$route.meta.y)
                // document.documentElement.scrollTop = vm.$route.meta.y
                // console.log(vm)
                if(from.path === '/login'){
                    vm.$backTop()
                    vm.onRefresh()
                }
                else if(from.path === '/my' && from.meta.logout === true){
                    vm.$backTop()
                    from.meta.logout = false
                    vm.onRefresh()
                }
            })
        }
    }
</script>

<style scoped>
    /*.van-swipe{height: calc(100vh - 100px);}*/
    /*.van-swipe-item{overflow-y: auto;}*/
    /*.van-pull-refresh {*/
    /*    height: calc(100vh - 100px) !important;*/
    /*    overflow: auto !important;*/
    /*}*/
    /*.van-list { height: auto !important; }*/
</style>
